module.exports = __webpack_public_path__ + "img/h5img2.eb5be8eb.png";